//
//
//

import Vue from 'vue'
import mintUi from 'mint-ui'
import '../../assets/css/base.scss'
import '../../assets/css/common.scss'
import '../../assets/css/font/iconfont.css'
Vue.use(mintUi)
export default {
    mixins: [], 
    name: 'app',
    components: {}
}




// WEBPACK FOOTER //
// ./src/modules/search/App.vue